import {useState} from 'react';
import {createRsvp} from '../services/rsvpService';

const initialForm = {
  guest_name: '',
  email: '',
  attendance: 'Yes',
  guest_count: '1',
  dietary_requirements: '',
  message: '',
};

export default function Rsvp({copy, formCopy}) {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle');

  const updateField = (event) => {
    const {name, value} = event.target;
    setForm((current) => ({...current, [name]: value}));
  };

  const submitRsvp = async (event) => {
    event.preventDefault();
    setStatus('saving');
    try {
      await createRsvp(form);
      setForm(initialForm);
      setStatus('success');
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <section id="rsvp" className="rsvp section-shell">
      <div className="rsvp-heading">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h2>{copy.title}</h2>
        <p>{copy.copy}</p>
      </div>
      <form className="rsvp-form" onSubmit={submitRsvp}>
        <div className="gf-field">
          <label className="gf-label" htmlFor="guest_name">{formCopy.name}</label>
          <input
            className="gf-input"
            id="guest_name"
            name="guest_name"
            value={form.guest_name}
            onChange={updateField}
            placeholder={formCopy.namePlaceholder}
            required
          />
        </div>
        <div className="gf-field">
          <label className="gf-label" htmlFor="email">{formCopy.email}</label>
          <input
            className="gf-input"
            id="email"
            name="email"
            type="email"
            value={form.email}
            onChange={updateField}
            placeholder={formCopy.emailPlaceholder}
            required
          />
        </div>
        <div className="gf-field">
          <label className="gf-label" htmlFor="attendance">{formCopy.attendance}</label>
          <select
            className="gf-input"
            id="attendance"
            name="attendance"
            value={form.attendance}
            onChange={updateField}
          >
            <option value="Yes">{formCopy.yes}</option>
            <option value="No">{formCopy.no}</option>
          </select>
        </div>
        <div className="gf-field">
          <label className="gf-label" htmlFor="guest_count">{formCopy.guestCount}</label>
          <input
            className="gf-input"
            id="guest_count"
            name="guest_count"
            type="number"
            min="1"
            max="10"
            value={form.guest_count}
            onChange={updateField}
            placeholder={formCopy.guestCountPlaceholder}
            required
          />
        </div>
        <div className="gf-field">
          <label className="gf-label" htmlFor="dietary_requirements">
            {formCopy.dietary}
          </label>
          <textarea
            className="gf-input"
            id="dietary_requirements"
            name="dietary_requirements"
            value={form.dietary_requirements}
            onChange={updateField}
            placeholder={formCopy.dietaryPlaceholder}
            rows="2"
          />
        </div>
        <div className="gf-field">
          <label className="gf-label" htmlFor="message">{formCopy.message}</label>
          <textarea
            className="gf-input"
            id="message"
            name="message"
            value={form.message}
            onChange={updateField}
            placeholder={formCopy.messagePlaceholder}
            rows="2"
          />
        </div>
        <button className="gf-submit" type="submit" disabled={status === 'saving'}>
          {status === 'saving' ? formCopy.sending : formCopy.submit}
        </button>
        {status === 'success' && <p role="status">{formCopy.success}</p>}
        {status === 'error' && <p role="alert">{formCopy.error}</p>}
      </form>
    </section>
  );
}